import { Checkbox } from 'src/components/Checkbox';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

interface CheckboxFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

export const CheckboxFilter: React.FC<CheckboxFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  if (valueOnly) {
    return <>{String(value) === 'true' ? label : ''}</>;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Checkbox
        checked={String(value) === 'true'}
        onChange={(e) => setValue(e.target.checked ? 'true' : '')}
      />
      <Typography>{label}</Typography>
    </Stack>
  );
};
